/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export enum ThemeFields {
  Breakpoints = 'breakpoints',
  FontSizes = 'fontSizes',
  FontFaces = 'fontFaces',

  Colors = 'colors',
  Shadows = 'shadows',
  ButtonVariants = 'buttonVariants',
  Padding = 'padding',
}

export enum PaddingFields {
  ButtonRegular = 'buttonRegular',
  ButtonSmall = 'buttonSmall',
}

export enum ColorVariants {
  Primary = 'primary',
  Success = 'success',
  Danger = 'danger',
  Warn = 'warn',
  Info = 'info',
}

export enum FontSizesFields {
  Smaller = 'smaller',
  Small = 'small',
  Regular = 'regular',
  H3 = 'h3',
  H2 = 'h2',
  H1 = 'h1',
  Big = 'big',
  Huge = 'huge',
}
export enum FontFacesFields {
  Sans = 'sans',
  Serif = 'serif',
}

export enum ColorsFields {
  Text = 'text',
  TextInverted = 'textInverted',
  TextInactive = 'textInactive',
  TextSuccess = 'successText',
  TextDanger = 'dangerText',
  Highlight = 'highlight',
  Main = 'main',
  MainLight = 'mainLight',
  BackgroundMain = 'backgroundMain',
  BackgroundOverlay = 'backgroundOverlay',
  Border = 'border',
  Primary = 'primary',
  PrimaryDarken = 'primaryDarken',
  PrimaryLighten = 'primaryLighten',
  Danger = 'danger',
  DangerDarken = 'dangerDarken',
  DangerLighten = 'dangerLighten',
  Success = 'success',
  SuccessDarken = 'successDarken',
  SuccessLighten = 'successLighten',
  ControlNeutral = 'controlNeutral',
  ControlActive = 'controlActive',
  Button = 'mainButton',
  SelectedToggleButton = 'selectedToggleButton',
  LightText = 'lightText',
  SelectedToggleText = 'selectedToggleText',
  HoverLightBackground = 'hoverLightBackground',
}

export enum ShadowsFields {
  Button = 'button',
  ButtonGroupShadow = 'buttonGroupShadow',
}
